<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.inventory'),
                        href: meta.links.inventory_index,
                    },
                    {
                        name: $tc('messages.gamification_trades', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.create" element="inertia-link">
                {{ $t('messages.create') }}
            </AppButton>
        </div>

        <EmptyState picture v-if="trades.data.length === 0" />
        <div class="md:grid md:grid-cols-2 md:gap-6" v-else>
            <CardPanel v-for="trade in trades.data" :key="trade.id">
                <div class="md:flex gap-x-2">
                    <div>
                        <div>
                            {{ trade.date_display }}
                        </div>
                        <div>
                            <div class="flex md:justify-center">
                                <IconArrowsLeftRight
                                    class="w-16 h-16"
                                    :class="{
                                        'text-indigo-200': trade.status === null,
                                        'text-green-200': trade.status === 'finished',
                                        'text-yellow-200': trade.status === 'error',
                                    }"
                                />
                            </div>
                        </div>
                        <div v-if="trade.status === 'error'">
                            <BadgePill color="yellow">
                                {{ $t('messages.error') }}:
                                {{ $t('messages.quantity') }}
                            </BadgePill>
                        </div>
                        <div>
                            <InertiaSquareLinkButton action="show" :href="trade.links.show" v-if="trade.links.show" />
                        </div>
                    </div>
                    <AppWell class="flex-1">
                        <AppCard>
                            <div class="flex gap-x-2 md:gap-x-4">
                                <img
                                    class="w-16 h-16 rounded-full"
                                    :src="trade.first.avatar_or_profile_photo"
                                    :title="trade.first.first_name_and_initial"
                                    alt="Avatar"
                                />
                                <div>
                                    <div class="mt-1 rounded-md shadow-sm" v-if="trade.settings.coins.first">
                                        <img
                                            class="h-6 w-6 mr-1"
                                            src="/assets/gamification/currency/coin.svg"
                                            alt="emerald"
                                        />
                                        <div>
                                            {{ trade.settings.coins.first }}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <TradeElementsDisplay
                                            side="first"
                                            :elements="options.items"
                                            :selected="trade.settings.items"
                                            element-class="h-12 w-12"
                                        />
                                    </div>
                                    <div class="mt-2">
                                        <TradeElementsDisplay
                                            side="first"
                                            :elements="options.cards"
                                            :selected="trade.settings.cards"
                                            element-class="h-12 w-12"
                                        />
                                    </div>
                                </div>
                            </div>
                        </AppCard>
                        <AppCard class="mt-3">
                            <div class="flex gap-x-2 md:gap-x-4">
                                <img
                                    class="w-16 h-16 rounded-full"
                                    :src="trade.second.avatar_or_profile_photo"
                                    :title="trade.second.first_name_and_initial"
                                    alt="Avatar"
                                />
                                <div>
                                    <div class="mt-1 rounded-md shadow-sm" v-if="trade.settings.coins.second">
                                        <img
                                            class="h-6 w-6 mr-1"
                                            src="/assets/gamification/currency/coin.svg"
                                            alt="emerald"
                                        />
                                        <div>
                                            {{ trade.settings.coins.second }}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <TradeElementsDisplay
                                            side="second"
                                            :elements="options.items"
                                            :selected="trade.settings.items"
                                            element-class="h-12 w-12"
                                        />
                                    </div>
                                    <div class="mt-2">
                                        <TradeElementsDisplay
                                            side="second"
                                            :elements="options.cards"
                                            :selected="trade.settings.cards"
                                            element-class="h-12 w-12"
                                        />
                                    </div>
                                </div>
                            </div>
                        </AppCard>
                    </AppWell>
                </div>
                <AlertMessage v-if="trade.status === 'error'" class="mt-3">
                    <template v-slot:body>
                        {{ trade.trade_error_explanation }}
                    </template>
                </AlertMessage>
            </CardPanel>
        </div>
        <template v-slot:pagination>
            <InertiaPagination :paginator="trades" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import CardPanel from '@/Shared/CardPanel.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import BadgePill from '@/components/BadgePill.vue';
import { IconArrowsLeftRight } from '@tabler/icons-vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import TradeElementsDisplay from '@/components/TradeElementsDisplay.vue';
import AlertMessage from '@/components/AlertMessage.vue';

export default {
    components: {
        AlertMessage,
        TradeElementsDisplay,
        AppCard,
        AppWell,
        InertiaPagination,
        EmptyState,
        PanelPage,
        AppButton,
        CardPanel,
        InertiaSquareLinkButton,
        BadgePill,
        IconArrowsLeftRight,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'trades', 'filters', 'options'],
    data() {
        return {
            form: this.$inertia.form({}),
        };
    },
    methods: {},
};
</script>

<style scoped>
details summary::-webkit-details-marker,
details summary::marker {
    display: none;
    content: '';
}
</style>
